import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import ChatWorkSheet from '../../components/ChatWorkSheet';
import Helmet from '../../components/Helmet';

export interface HomeProps extends MuiBoxProps {}

export const ChatWorkSheetPage = ({ className }: HomeProps) => {
  return (
    <>
      <Helmet />
      <ChatWorkSheet />
    </>
  );
};

ChatWorkSheetPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ChatWorkSheetPage.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(ChatWorkSheetPage)(
  ({ theme }) => `
`,
);
